export const getGlobalThis = () => {
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw new Error('unable to locate global object')
}

export const lstorage = {
  /**
   * 设置localstorage
   * @param {String} key 健
   * @param {Object} val 值
   */
  setItem (key, val) {
    if (key) {
      try {
        window.localStorage.setItem(key, JSON.stringify(val));
      } catch (e) {
        console.log(e, 'ls set error');
      }
    }
  },
  /**
   * 获取localstorage
   * @param {String} key 健
   * @return Object     值
   */
  getItem (key) {
    if (key) {
      try {
        const val = window.localStorage.getItem(key);
        if (val) return JSON.parse(val);
      } catch (e) {
        return null;
      }
    }
    return null;
  },
  /**
   * 移除localstorage
   * @param {String} key 健
   */
  removeItem (key) {
    if (key) {
      try {
        window.localStorage.removeItem(key);
      } catch (e) {
        console.log(e, 'ls remove error');
      }
    }
  }
};

/**
 * 日期格式化
 * @param  {Date}   date   日期
 * @param  {String} format 输出的日期格式
 * @return String        格式化之后的日期
 */
export const dateFormat = (date, format = 'YYYY-MM-DD') => {
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "D+": date.getDate(), // 日
  };
  if (/(Y+)/.test(format)) {
    format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
}

// 获取cookie
/**
 * 根据指定key获取cookie值
 * @param  {String} name 健
 * @return String      值
 */
export function getCookie (name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return '';
}

/**
 * Object.values 的兼容处理
 * @param {Object} obj - 需要获取值的对象
 * @return {Array} - 对象的值数组
 */
export function objectValues(obj) {
  if (Object.values) {
    return Object.values(obj);
  }
  return Object.keys(obj).map(function(key) {
    return obj[key];
  });
}

/**
 * Object.entries 的兼容处理
 * @param {Object} obj - 需要获取键值对的对象
 * @return {Array} - 对象的键值对数组
 */
export function objectEntries(obj) {
  if (Object.entries) {
    return Object.entries(obj);
  }
  return Object.keys(obj).map(function(key) {
    return [key, obj[key]];
  });
}
